/* Maverick Metals — light/dark theme controller.
   The no-flash inline script in layout/theme.liquid sets the initial
   data-theme (stored 'mm_theme' wins, else OS prefers-color-scheme).
   This file wires the header toggle and keeps the UI following the OS
   until the visitor makes a manual choice. */
(function () {
  var KEY = 'mm_theme';
  var root = document.documentElement;

  function stored() {
    try {
      var v = localStorage.getItem(KEY);
      return v === 'dark' || v === 'light' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function current() {
    return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function apply(theme, persist) {
    root.setAttribute('data-theme', theme);
    if (persist) {
      try { localStorage.setItem(KEY, theme); } catch (e) {}
    }
    document.querySelectorAll('[data-mm-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
    root.dispatchEvent(new CustomEvent('mm:themechange', { detail: { theme: theme } }));
  }

  function toggle() {
    apply(current() === 'dark' ? 'light' : 'dark', true);
  }

  // Delegate clicks so toggles added by any section just work.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mm-theme-toggle]');
    if (btn) {
      e.preventDefault();
      toggle();
    }
  });

  // Follow OS changes until the visitor picks a theme manually.
  if (window.matchMedia) {
    var mq = window.matchMedia('(prefers-color-scheme: dark)');
    var onChange = function () {
      if (!stored()) apply(mq.matches ? 'dark' : 'light', false);
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  // Sync initial aria-pressed state on any existing toggles.
  apply(current(), false);
})();
